import {useCallback, useState} from 'react';
import {ColorChangeHandler} from 'react-color';
import {useViewStore} from 'stores/view';

export const useColorPicker = (defaultColor: string, isolatedView?: boolean) => {
    const backgroundColor = useViewStore.use.backgroundColor();
    const setBackgroundColor = useViewStore.use.setBackgroundColor();

    const [showColorPicker, setShowColorPicker] = useState(false);

    const toggleColorPicker = useCallback(() => {
        setShowColorPicker((s) => !s);
    }, []);

    const onChange: ColorChangeHandler = useCallback(
        (color) => setBackgroundColor(`rgba(${color.rgb.r},${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a ?? 1})`),
        [setBackgroundColor]
    );

    return {onChange, toggleColorPicker, showColorPicker, color: backgroundColor || defaultColor};
};
